export default __webpack_public_path__ + "96566bfef5db46d345b6ebd85c1e3585.woff";